import { createSelector } from 'reselect'
import { List } from 'immutable'

import { selectGroupConfig } from './selectGroupConfig'

export const selectAccounts = createSelector([selectGroupConfig], (groupConfig) =>
  groupConfig.get('group_services') ? List(groupConfig.get('group_services').keySeq()) : new List()
)
